import ResponsiveLayout from 'containers/Layouts/ResponsiveLayout'
import { Grid , Paper, Box } from '@material-ui/core';

import ExaminationTable from 'containers/Examination/Components/ExaminationTable';
import DashboardActions from 'containers/Examination/Components/DashboardActions'

import './Examination.css'

const ExaminationDashboard = () => {
  return (
    <ResponsiveLayout>
      <Box container display="flex" justifyContent="center">
        <Grid item lg={8}>
          <Paper className='w-full p-5'>
            <DashboardActions />
            <ExaminationTable />
          </Paper>
        </Grid>
      </Box>
    </ResponsiveLayout>
  )
}

export default ExaminationDashboard;